import request from './core/request'

// 代购平台账号相关API
export default {
	//获取我的代购平台账号
	getList: (params) => request.get('/goods/platform-account', params),
	//获取代购平台账号
	getById: (id) => request.get(`/goods/platform-account/${id}`),
	//添加代购平台账号
	add: (data) => request.post('/goods/platform-account', data),
	//编辑代购平台账号
	update: (id, data) => request.put(`/goods/platform-account/${id}`, data),
	//删除代购平台账号
	delete: (id) => request.delete(`/goods/platform-account/${id}`),
	//设置默认代购平台账号
	setDefault: (id) => request.put(`/goods/platform-account/setDefault/${id}`),
	//上移
	moveUp: (id, prevId) => request.put(`/goods/platform-account/moveUp/${id}/${prevId}`),
	//下移
	moveDown: (id, nextId) => request.put(`/goods/platform-account/moveDown/${id}/${nextId}`)
}